import { render, staticRenderFns } from "./Adminmanage.vue?vue&type=template&id=72d2c83a"
import script from "./Adminmanage.vue?vue&type=script&lang=js"
export * from "./Adminmanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports